import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import ChildLink from 'gatsby-theme-menus/src/components/nav/list-nav/child-link';
import activeClassName from 'gatsby-theme-menus/src/components/nav/activeClassName';

export default styled(ChildLink)`
  padding-right: 4rem;
  text-decoration: none;
  transition: .2s;

  color: ${({ theme }) => theme.fontColor};
  &.${activeClassName},
  &:hover {
    background-color: ${({ theme }) => theme.primaryColor};
    color: ${({ theme }) => theme.backgroundColor};
  }

  ${({ $hasColumn, theme }) => $hasColumn && css`
    && {
      display: inline-block;
      color: ${theme.primaryColor};
      background-color: white;
      &.${activeClassName},
      &:hover {
        background-color: ${transparentize(0.85, theme.primaryColor)};
      }
    }
  `}
`;
